import { DealerLocationID } from "./DealerLocation";
import { UserID } from "./User";

export type OneiPlanningMonteurID = number;

export interface OneiPlanningMonteur {
  created_on: string;
  updated_on: string;
  onei_planning_monteur_id: OneiPlanningMonteurID;
  onei_location: string;
  onei_code: string;
  onei_monteur_name: string;
  onei_dealer_location_id: DealerLocationID;
  onei_user_id: UserID | null;
}
